// Module
var code = `<div ng-if="!vm.fonctionHidden"> <div class="ex-button-historique-colonne"> <md-button ng-click="vm.openHistoriqueColonne(\$event)" class="md-icon-button ex-button-historique-colonne"> <md-icon>ballot</md-icon> <md-tooltip md-direction="top">{{'G_LBL_HISTORIQUE_COLONNE' | exLibelle}}</md-tooltip> </md-button> </div> </div>`;
// Exports
module.exports = code;